import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import {
  CompanyListParams,
  CompanyRegistrationParams,
  CompanyResponse,
  CompanyUpdateParams,
} from "../types";

export const companyService = {
  async registerCompany(
    params: CompanyRegistrationParams
  ): Promise<ApiResponse<string>> {
    return apiClient.post("/gestorEntregoCadastroFranquia", params);
  },

  async updateCompanyCredentials(
    params: CompanyUpdateParams
  ): Promise<ApiResponse<string>> {
    return apiClient.post("/gestorEntregoCadastroFranquia", params);
  },

  async getCompanies(
    params: CompanyListParams
  ): Promise<ApiResponse<{ data: CompanyResponse[] }>> {
    return apiClient.post("/gestorEntregoCadastroViz", params);
  },
};
